import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { TaxAttributesComponent } from '../tax-attributes.component';

/**
 * Main “Tax Attributes” tab content (not entity create/update/posting modals).
 */
@Component({
    selector: 'app-tax-attributes-main-panel',
    templateUrl: './tax-attributes-main-panel.component.html',
    styleUrls: ['../tax-attributes.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class TaxAttributesMainPanelComponent {
  @Input() ctx!: TaxAttributesComponent;
}
